import React, { useRef, useState, useEffect } from "react";
import "./CustomerProfile.scss";
import UserFace from "../../images/user.png";
import Camera from "../../images/camera-outline.svg";
import {
  getUserDetails,
  editUserDetails,
  PictureNew,
  CloseAccount,
  getCustomerTypes,
  getCustomerSubTypes,
  getUserDetailsNew,
  getGlobalPhoto,
} from "../../util/API/customers";
import { useSelector, useDispatch } from "react-redux";
import {
  convertFormsToJson,
  formatDate,
  getErrorMessage,
} from "../../util/utilfunctions/utilFunctions";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { generateValidationSchema } from "../../constants/formvalidation";
import CustomForm from "../UI/CustomForm/CustomForm";
import PinPad from "../PinPad/PinPad";
import { Box, Typography } from "@mui/material";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import { removeFromPreviousUsers } from "../../store/redux/previousUsers";
import { ConsumerResetPIN } from "../../util/API/passwordpinchange";
import BaseButton from "../UI/BaseButton/BaseButton";
import { activeInactiveMerchant, removeBusinessProfile } from "../../util/API/admin";
import CustomNewTabForm from "../UI/CustomNewTabForm/CustomNewTabForm";
import { countryAreaCode } from "../../constants/countrylist";

function CustomerProfile({
  selectedUser, 
  open,
  editAllowed,
  conditionalFields,
  handleClose,
  fetchTable
}) {
  const [userProfileData, setUserProfileData] = useState(null);
  const [userData, setUserData] = useState({
    firstName: "",
    otherNames: "",
    lastName: "",
    email: "",
    telephoneno: "",
    dateofbirth: "",
    username: "",
    dateAdded: "",
    error: "",
    photo: "",
    base64Image: "",
    contactPhoneNo: "",
    gender: "",
    address: "",
    city: "",
    country: "",
    stateid: "",
    zip: "",
  });
  const [pictureData, setPictureData] = useState({
    base64Image: "",
    photo: "",
    status: ""
  })
  const [updated, setUpdated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState([]);
  const [loadForms, setLoadForms] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showPinPad, setShowPinPad] = useState(false);
  const [alert, setAlert] = useState({
    showAlert: false,
    message: "",
    severity: "",
    header: "",
    onConfirm: null,
    alertType: ''
  });
  const [role, setRole] = useState([]);
  const [hasPendingPhoto, setHasPendingPhoto] = useState(false);

  const customFormRef = useRef();
  const [closeButtonDisabled, setCloseButtonDisabled] = useState(false);
  const [formHeight, setFormHeight] = useState(window.innerHeight * 0.51); // Initial height

  const [customerTypes, setCustomerTypes] = useState([]);
  const [customerSubTypes, setCustomerSubTypes] = useState([]);
  const [selectedCustomerType, setSelectedCustomerType] = useState("");
  const [oldBase64Img, setOldBase64Img] = useState("");

  const requiredConstants = useSelector((state) => state.constants);
  let isSuperAdmin = sessionStorage.getItem("isSuperAdmin");
  let isOperator = sessionStorage.getItem("isOperator");
  let configVariables = useSelector((state) => state.config.baseConfig);
  let imageUrl = configVariables.imageURL;

  useEffect(() => {
    const handleResize = () => {
      const adjustedHeight = window.innerHeight * 0.51; // Adjust height
      setFormHeight(adjustedHeight);
    };

    // Add event listener on resize
    window.addEventListener("resize", handleResize);

    // Clean up event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const customerProfileConditionalFields = {
    newusersubtype: (value, watch) => (userProfileData?.User?.usersubtype !== userProfileData?.User?.newusersubtype) && userProfileData?.User?.newusersubtype !== "" && userProfileData?.User?.newusersubtype !== "0",
    peppersons: (value, watch) => watch("politicallyexposed") === "1",
    merchantFirstName: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    merchantLastName: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businessname: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businessphoneno: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businessaddress1: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businessaddress2: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businesscity: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businesscountry: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businessstate: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businesszipcode: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    industry: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    legalstructure: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
  }


  let pin = sessionStorage.getItem("pin");

  const user = useSelector((state) => state.usersList.userID);
  const dispatch = useDispatch();
  const validationSchema = generateValidationSchema(formData);
  let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body;

  const {
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  //This is a useEffect to get the form data from the API
  useEffect(() => {
    const getForm = async () => {
      setLoadForms(true);
      try {
        const response = await fetch("/forms/newuser1.json");
        const formResponseData = await response.json();

        const convertedForms = convertFormsToJson(formResponseData);
        setFormData(convertedForms);
        setLoadForms(false);
      } catch (error) {
      }
    };

    getForm();
  }, []);

  const fieldMappings = {
    firstName: "firstName",
    middleName: "otherNames", 
    lastName: "lastName",
    email: "emailAccount",
    phoneno: "telephoneno",
    dob: "dateofbirth",
    pob: "placeofbirth",
    gender: "gender",
    address: "address1",
    address2: "address2",
    city: "cityname",
    state: "stateid",
    country: "countryid",
    zip: "zip",
    nationalitycountry: "nationalitycountry",
    classification: "classification",
    occupation: "occupation",
    sourceofincome: "sourceofincome",
    lofrelationship: "dateAdded",
    purpose: "purpose", 
    langID: "langID",
    fee: "fee", 
    birthcountry: "birthcountry",
    birthstate: "birthstate",
    citizenshipcountry: "citizenshipcountry",
    citizenshipatbirthcountry: "citizenshipatbirthcountry",
    politicallyexposed: "ispoliticallyexposed",
    peppersons: "peppersons",
    ismerchant: "ismerchant",
    officialname: "officialname",
    businessname: "businessname", 
    businessphoneno: "businessphoneno", 
    employername: "employername",
    businessaddress1: "businessaddress1", 
    businessaddress2: "businessaddress2", 
    businesscity: "businesscity", 
    businesscountry: "businesscountry", 
    businessstate: "businessstate", 
    businesszipcode: "businesszipcode", 
    industry: "industry", 
    legalstructure: "legalstructure",
    contactPhoneNo: "contactPhoneNo",
    dateAdded: "dateAdded",
    customersubtype:"customersubtype",
    customertype:"customertype",
    newusersubtype:"newusersubtype",
    secondaryemail:"secondaryemail"
  };

  const mapFormToBackend = (formValues) => {
    const mappedValues = {};
    let extendedFields = {};
    try {
      extendedFields = JSON.parse(
        user['User'].extendedfields.replaceAll(/&(amp;)*quot;/g, '"')
        );
      } catch (error) {
        console.error("Failed to parse extended fields:", error);
      }
      
      // Loop through fieldMappings to ensure only mapped keys are used
      for (const [formKey, backendKey] of Object.entries(fieldMappings)) {
        if (formValues[formKey] !== undefined) { 
          backendKey === "dateofbirth" ? 
          mappedValues["dob"] = formValues["dob"] :
          mappedValues[backendKey] = formValues[formKey]; // Use mapped key and value
        }
      }
      
      // 2. Add extended fields to mappedValues dynamically
      if(extendedFields !== null) {
        for (const [key, defaultValue] of Object.entries(extendedFields)) {
          if (!mappedValues.hasOwnProperty(key)) {
            mappedValues[key] = formValues[key] !== undefined ? formValues[key] : defaultValue;
          }
        }
      }
      
    return mappedValues;
  };

  const mapBackendToForm = (backendData) => {
    const mappedData = {};
  
    // Loop through fieldMappings to ensure only mapped keys are used
    for (const [formKey, backendKey] of Object.entries(fieldMappings)) {
      if (backendData[backendKey] !== undefined) {
        mappedData[formKey] = backendData[backendKey]; // Use form key and value
      }
    }

    for (const key in backendData) {
      if (!Object.values(fieldMappings).includes(key)) {
        mappedData[key] = backendData[key]; // Add unmapped field
      }
    }
  
    return mappedData;
  };

  const fetchCustomerSubType = async () => {
    try {
      const res = await getCustomerSubTypes(202, selectedCustomerType);

      // Handle both cases: array and single object
      const record = res?.data?.body?.record;

      // Check if record is an array or a single object
      const transformedSubCustomerType = Array.isArray(record)
        ? record.map((item) => ({
            key: item.usersubtype.subtypeID,
            value: item.usersubtype.subtypeID,
            label: item.usersubtype.name,
          }))
        : record?.usersubtype // If single object
        ? [
            {
              key: record.usersubtype.subtypeID,
              value: record.usersubtype.subtypeID,
              label: record.usersubtype.name,
            },
          ]
        : [
            {
              key: "not-available",
              value: "not-available",
              label: "Not Available",
            },
          ];

      // Set the transformed data to state
      setCustomerSubTypes(transformedSubCustomerType);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
  };

  const fetchCustomerType = async () => {
    try {
      const res = await getCustomerTypes(201);
      const transformedCustomerType =
        (await res?.data?.body?.record?.length) > 0
          ? res?.data?.body?.record?.map((item) => ({
              key: item.usertype.typeID,
              value: item.usertype.typeID,
              label: item.usertype.name,
            }))
          : [
              {
                key: "not-available",
                value: "not-available",
                label: "Not Available",
              },
            ];
      setCustomerTypes(transformedCustomerType);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
  };

  useEffect(() => {
    async function getUserData() {
      const userDetails = await getUserDetailsNew(selectedUser);
      console.log("userDetails============",userDetails);
      setUserProfileData(userDetails)
      let extendedFields = userDetails.User.extendedfields;
      try {
        extendedFields = JSON.parse(
          extendedFields.replaceAll(/&(amp;)*quot;/g, '"')
        );
      } catch (err) {}

      const emailPattern = /CL\d+_/;

      if (emailPattern.test(userDetails.Useremailaccount.emailAccount)) {
        setCloseButtonDisabled(true);
      }

      console.log("extendedFields==========",extendedFields);

      const userAreaCode = await countryAreaCode.filter((country) => country.key == userDetails?.User?.telephonenocountrycode);

      const mappedUserData = mapBackendToForm({
        ...userDetails['User'],
        ...extendedFields,
        emailAccount: userDetails.Useremailaccount.emailAccount,
        email: userDetails.Useremailaccount.emailAccount,
        secondaryemail: userDetails.User.secondaryemail,
        extID: userDetails.extID,
        extIDType: userDetails.extIDType,
        placeofbirth: extendedFields?.placeofbirth,
        legalidtype: extendedFields?.legalidtype,
        idNumber: extendedFields?.legalidnumber,
        peppersons: extendedFields?.valuepoliticallyexposed,
        birthcountry: extendedFields?.birthcountry,
        birthstate: extendedFields?.birthstate,
        citizenshipcountry: extendedFields?.citizenshipcountry,
        citizenshipatbirthcountry: extendedFields?.citizenshipatbirthcountry,
        politicallyexposed: extendedFields?.ispoliticallyexposed,
        idexpiry: extendedFields?.legalidexpdate,
        brokername: userDetails.brokername,
        dateAdded: userDetails.User.dateAdded,
        photo: imageUrl + userDetails.User.photo,
        kycdataid: extendedFields?.kycdataid,
        employername: extendedFields?.employername,
        officialname: userDetails['merchantdata']['Merchant']?.officialname,
        businessname: userDetails['merchantdata']['Merchant']?.businessname,
        businessphoneno: userDetails['merchantdata']['Merchant']?.businessphoneno,
        businessaddress1: userDetails['merchantdata']['Merchant']?.businessaddress1,
        businessaddress2: userDetails['merchantdata']['Merchant']?.businessaddress2,
        businesscity: userDetails['merchantdata']['Merchant']?.businesscity,
        businesscountry: userDetails['merchantdata']['Merchant']?.businesscountry,
        businessstate: userDetails['merchantdata']['Merchant']?.businessstate,
        businesszipcode: userDetails['merchantdata']['Merchant']?.businesszipcode,
        industry: userDetails['merchantdata']['Merchant']?.industry,
        legalstructure: userDetails['merchantdata']['Merchant']?.legalstructure,
        ismerchant: userDetails['merchantdata'] && Object.keys(userDetails['merchantdata'])?.length > 0 && userDetails?.Securityuserrole?.length > 1 ? true : false,
        userType: userDetails.User.userType,
        usersubtype: userDetails.User.usersubtype,
        customertype:userDetails.User.userType,
        customersubtype: userDetails.User.usersubtype,
        areaCode: userAreaCode && userAreaCode?.length>0 ? userAreaCode[0] : null,
        showUpdatedSubtypeField: userDetails.User.usersubtype !== userDetails.User.newusersubtype,
      });

      setSelectedCustomerType(userDetails.User.userType);
  
      setUserData(mappedUserData);

      console.log("userDetails.User.photo============",userDetails.User.photo);

      // Set initial photo from userDetails (fallback)
      const initialPhotoUrl = userDetails.User.photo ? imageUrl + userDetails.User.photo : UserFace;

      setPictureData({
        photo: initialPhotoUrl,
        base64Image: initialPhotoUrl,
        status: "2",
      });
      setOldBase64Img(initialPhotoUrl);

      // Fetch latest profile photo via GetGlobalPhoto
      try {
        const globalPhotoResponse = await getGlobalPhoto("", selectedUser.toString());
        if (globalPhotoResponse?.payload?.body?.record?.[0]?.photo) {
          const latestPhotoUrl = imageUrl + globalPhotoResponse.payload.body.record[0].photo;
          setPictureData({
            photo: latestPhotoUrl,
            base64Image: latestPhotoUrl,
            status: "2",
          });
          setOldBase64Img(latestPhotoUrl);
        }
      } catch (err) {
        console.error("Failed to fetch global photo:", err);
        // Keep fallback photo if API fails
      }

      setUpdated(false);
      setHasPendingPhoto(false);
    }

    setSuccessMessage("");
    if (selectedUser) {
      getUserData();
      fetchCustomerType();
    }
  }, [selectedUser]);

  const onImageChange = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64 = e.target.result;
        setPictureData({
          photo: base64,
          base64Image: base64,
          status: pictureData.status,
        });
        setHasPendingPhoto(true);
      };
      reader.readAsDataURL(file);
    }
    event.target.value = "";
  };

  //This is a useEffect to set the user details into react hook forms
  useEffect(() => {
    if (userData) {
      Object.keys(userData).forEach((key) => {
        setValue(key, userData[key], { shouldValidate: true });
      });
    }

    if (pictureData) {
      Object.keys(pictureData).forEach((key) => {
        setValue(key, pictureData[key], { shouldValidate: true });
      });
    }
  }, [userData, setValue, pictureData]);

  const onSubmit = async (e) => {
    try {
      setSuccessMessage("");
      customFormRef.current.validateAndSetErrors();

      const values = customFormRef.current.getValues();
      const fieldsToTrigger = [];
      const conditionalFieldKeys = Object.keys(conditionalFields);

      const requiredFields = formData.reduce((acc, field) => {
        if (field.validation && field.validation.required !== 'undefined') {
          acc[field.name] = field.validation.required;
        }
        return acc;
      }, {});

      for (const [key, value] of Object.entries(values)) {
        const isConditional = conditionalFieldKeys.includes(key);
        const conditionMet = isConditional ? conditionalFields[key](value, customFormRef.current.watch) : false;

        if (
            (
              value === "null" || 
              value === "0000-00-00" || 
              value === "" ||
              value === null ||
              value === undefined
            ) 
            &&
            (!isConditional || (isConditional && conditionMet)) && requiredFields[key]) {
          fieldsToTrigger.push(key);
        }
      }

      if (fieldsToTrigger.length > 0) {
        const groupedFieldsEntries = Object.entries(customFormRef.current.getGroupedFields?.() || {});
        const firstErrorGroupIndex = groupedFieldsEntries.findIndex(([group, fields]) =>
          fields.some(field => fieldsToTrigger.includes(field.name))
        );
      
        if (firstErrorGroupIndex !== -1 && typeof customFormRef.current.setActiveTab === 'function') {
          customFormRef.current.setActiveTab(firstErrorGroupIndex);
        }
      
        customFormRef.current.setFocus(fieldsToTrigger[0]);
        await customFormRef.current.trigger(fieldsToTrigger);
        return;
      }

      
      let extendedFields = user['User'].extendedfields;
      try {
        extendedFields = JSON.parse(
          extendedFields.replaceAll(/&(amp;)*quot;/g, '"')
        );
      } catch (err) {
        console.log("extendedFields_err=========",err);
      }

      let mappedValues = mapFormToBackend(values);

      mappedValues.telephonenocountrycode = values?.areaCode?.key;
      mappedValues.contactphonenocountrycode = values?.areaCode?.key;
      
      if(userData?.usersubtype != mappedValues?.customersubtype) {
        const pad = (n) => (n < 10 ? '0' + n : n);
        const today = new Date();
        const nextMonthFirstDate = new Date(today.getFullYear(), today.getMonth() + 1, 1);
        const formattedDate = `${nextMonthFirstDate.getFullYear()}-${pad(nextMonthFirstDate.getMonth() + 1)}-${pad(nextMonthFirstDate.getDate())}`;
        mappedValues.newusertypeseffectivedate = formattedDate;

        mappedValues.customersubtype = userData?.usersubtype;
        mappedValues.customernewsubtype = values?.customersubtype;
      } else {
        mappedValues.customersubtype = userData?.usersubtype;
        mappedValues.customernewsubtype = values?.newusersubtype ? values?.newusersubtype : values?.customersubtype;
      }

      setLoading(true);
      const listData = Object.keys(mappedValues)
        .filter(
          (key) =>
            key !== "dateAdded" &&
            key !== "username" &&
            key !== "email" &&
            key !== "password" &&
            key !== "newpassword" &&
            key !== "error" &&
            key !== "photo" &&
            key !== "base64Image" &&
            key !== "valuepoliticallyexposed"
        )
        .map((key) => {
          if (key == "dateofbirth") {
            return `${[key]}|${formatDate(e[key])}`;
          } 
          else if (key == "peppersons") {
            return `${["valuepoliticallyexposed"]}|${mappedValues[key]}`;
          }
          else {
            return `${key}|${mappedValues[key]}`;
          }
        })
        .join("//");

      // Upload new photo if one is pending
      if (hasPendingPhoto && pictureData.base64Image && pictureData.base64Image.startsWith('data:')) {
        const photoResponse = await PictureNew(selectedUser, pictureData.base64Image);
        // if (photoResponse?.Status !== "1" || photoResponse?.Status !== "2") {
        //   setAlert({
        //     showAlert: true,
        //     message: "Photo upload failed. Profile changes saved without new photo.",
        //     severity: "success",
        //     header: "success",
        //   });
        // }
      }

      const updatedDetails = await editUserDetails(selectedUser, listData, "", "", "", userData.screenresult);
      if (updatedDetails.payload.callStatus == 1) {
        setUpdated(true);
        setHasPendingPhoto(false);
      }

      if (updatedDetails.payload.callStatus == 1 || updatedDetails.payload.callStatus == 2 ) {
        fetchTable()
        setAlert({
          ...alert,
          showAlert: true,
          message: "User Account Updated Successfully",
          severity: "success",
          header: "Success",
        });
      }
      else {
        setAlert({
          ...alert,
          showAlert: true,
          message: getErrorMessage(updatedDetails),
          severity: "error",
          header: "Error",
        });
      }
      setLoading(false);
    } catch (error) {
      console.log("onSubmit_error=========",error);
    } finally {
      setLoading(false);
    }
  };

  const handleConfirm = (event, pin) => {
    let PIN = pin.join("");
    handleCloseAccount(event, PIN);
  };

  const pinConfiguration = useSelector((state) => state.login.pinConfiguration);

  const handleCloseAccount = async (event, PIN) => {
    const response = await CloseAccount(user["User"].id, agent['User'].id, PIN).then(
      (response) => {
        if (response.Status === "1") {
          setCloseButtonDisabled(true);
          setAlert({
            ...alert,
            showAlert: true,
            message: "Account Closed Successfully",
            severity: "success",
            header: "Success",
          });

          if (pinConfiguration === "once") {
            sessionStorage.setItem("pin", PIN);
          }
          
          dispatch(removeFromPreviousUsers(user["User"].id));
        } else {
          const message = response?.payload?.msg
          setAlert({
            ...alert,
            showAlert: true,
            message: "Error: " + message,
            severity: "error",
            header: "Error",
          });
        }
      }
    );

    setShowPinPad(false)
  };

  const handleRemoveBusinessAccount = async () => {
    const response = await removeBusinessProfile(user["User"].id).then(
      async(response) => {
        if (response?.data?.header?.callStatus === "1") {
          const response2 = await activeInactiveMerchant("", user["User"].id, 0).then((response2)=> {
            if (response2?.data?.header?.callStatus === "1") {
              setAlert({
                ...alert,
                showAlert: true,
                message: "Business Account Removed Successfully",
                severity: "success",
                header: "Success",
              });
            } else if(response2?.callStatus == 0) {
              const message = response2?.msg
              setAlert({
                ...alert,
                showAlert: true,
                message: "Error: " + message,
                severity: "error",
                header: "Error",
              });
            } else {
              const message = response2?.payload?.msg
              setAlert({
                ...alert,
                showAlert: true,
                message: "Error: " + message,
                severity: "error",
                header: "Error",
              });
            }
          });
          
        } else if(response?.callStatus == 0) {
          const message = response?.msg
          setAlert({
            ...alert,
            showAlert: true,
            message: "Error: " + message,
            severity: "error",
            header: "Error",
          });
        } else {
          const message = response?.payload?.msg
          setAlert({
            ...alert,
            showAlert: true,
            message: "Error: " + message,
            severity: "error",
            header: "Error",
          });
        }
      }
    );
  };

  const conditionalGroups = {
    "Business Information": (watch) => watch("ismerchant") === true || watch("ismerchant") === "true", 
  }

  const systemRoles = async () => {
    const userRoles = user['Securityuserrole'];
    
    const filteredRoles = requiredConstants.systemRoles.filter(role => {
      if (Array.isArray(userRoles)) {
        return userRoles.some(userRole => userRole.roleid === role?.securityrole?.roleid);
      } else {
        return userRoles?.roleid === role?.securityrole?.roleid;
      }
    }) || "";
    setRole(filteredRoles);
  };

  useEffect(() => {
    systemRoles()
  }, [])

  const confirmResetPin = () => {
    setAlert({
      ...alert,
      showAlert: true,
      message: "Are you sure you want to reset your PIN for " + user['Useremailaccount'].emailAccount + "?",
      severity: "confirm",
      header: "Please Confirm",
      alertType: 'confirm',
      onConfirm: () => resetConsumerPIN()
    })
  }


  const resetConsumerPIN = async () => {

    const response = await ConsumerResetPIN(
      user['Useremailaccount'].emailAccount,
      user['User'].id,
      user['User'].langID,
      user['User'].countryid,
      user['User'].franchiseeID
    );
    if (response.callStatus === "1") {
      setAlert({
        ...alert,
        showAlert: true,
        message: "PIN Reset Successfully",
        severity: "success",
        header: "Success",
      });
    } else {
      const message = response?.payload?.msg
      setAlert({
        ...alert,
        showAlert: true,
        message: "Error: " + message,
        severity: "error",
        header: "Error",
      });
    }

  };

  useEffect(()=> {
    if(selectedCustomerType) {
      fetchCustomerSubType();
    }
  },[selectedCustomerType])

  return (
    <Box 
      className="customer-porfile-container"
      sx={{
        display: "flex",
        flexDirection: "row",
        padding: "20px",
        gap: "20px",
        overflow: "auto",
      }}
    >
      <Box className="customer-photos">
        <Box className="customer-photo-container">
          <Box>
            <img
              className="user-profile"
              src={
                pictureData?.base64Image && pictureData.base64Image.startsWith('data:')
                  ? pictureData.base64Image
                  : pictureData?.photo && pictureData?.status === "2"
                  ? pictureData.photo
                  : UserFace
              }
              alt="User profile"
              loading="lazy"
            />
          </Box>
          <button>
            <Typography
              component="label"
              htmlFor="upload-input"
              style={{ cursor: "pointer", display: "block", width: "100%" }}
            >
              <Box className="user-upload-button">
                <input
                  type="file"
                  id="upload-input"
                  name="myImage"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={onImageChange}
                  disabled={selectedUser ? false : true}
                />
                <Box style={{ flex: 1 }}>{/* <img src={Camera} /> */}</Box>
                <Box style={{ flex: 2 }}>
                  {pictureData?.base64Image && pictureData.base64Image.startsWith('data:') && oldBase64Img !== pictureData.base64Image
                    ? "Change Photo"
                    : "Upload"}
                </Box>
                <Box style={{ flex: 1 }}>
                  <img src={Camera} alt="Camera" loading="lazy" />
                </Box>
              </Box>
            </Typography>
          </button>
        </Box>
        <Box className="registration-date-container">
          <Box className="registration-label">Registration Date</Box>
          <Box className="registration-date"> {userData.dateAdded.slice(0, 10)} </Box>
        </Box>

        <Box sx={{fontSize: "13px"}}>
          <b>User ID: </b>
          <br /> {selectedUser} <br />
          <b> {userData?.extIDType}: </b>
          <br /> {userData?.extID} <br />
          <b>KYC Policy Id: </b>
          <br /> {userData?.kycpolicyid} <br />
          <b>Broker Name: </b>
          <br /> {userData?.brokername} <br />
          <b> Default Login: </b>
          <br /> {userData?.email} <br />
          <b> Account Type: </b>
          <br /> {role.map(r => r?.securityrole?.name).join(', ')} <br />
        </Box>
        {successMessage && <Box className="text-center">{successMessage}</Box>}
        <Box className="text-center pt-3" sx={{ display: "flex", flexDirection: "column"}}>
          {isSuperAdmin === "true" && 
            <>
              <BaseButton
                buttonText={userProfileData?.User?.status == "4" ? "Account Closed" : "Close Account"}
                disabled={closeButtonDisabled}
                buttonStyle="tertiary-style"
                onClick={(e) => {
                  {
                    pin ? handleCloseAccount(e, pin) : pinConfiguration === "never" ? handleCloseAccount(e, '0000') : setShowPinPad(true);
                  }
                }}
                sx={{ textTransform: "none" }}
              />

              {user['User']?.corporate !== "0" && role?.length > 1 && <BaseButton
                buttonText="Remove Business Profile"
                buttonStyle="tertiary-style"
                disabled = {user['User']?.corporate === "0" && role?.length === 1}
                onClick={(e) => {
                    setAlert({
                      ...alert,
                      showAlert: true,
                      message: "Are you sure you want to remove this business profile?",
                      severity: "confirm",
                      header: "Please Confirm",
                      alertType: 'confirm',
                      onConfirm: () => handleRemoveBusinessAccount(),
                    })
                }}
                sx={{ textTransform: "none" }}
              />}
            </>
          }
          <BaseButton
            buttonText="PIN Reset"
            onClick={confirmResetPin}
            buttonStyle="tertiary-style"
            sx={{ textTransform: "none" }}
          />
        </Box>
      </Box>
      {!loadForms && (
        <Box 
          sx={{ 
            width: "50%",
            flex: 8, 
          }}
        >
          <Box 
            sx={{
              flex: 8,
              maxHeight: formHeight,
              overflowY: "scroll",
              
              '@media (min-width: 1920px)': {
                maxHeight: "572px",
              },
              '&::-webkit-scrollbar': {
                width: '4px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#cccccc',
              },
            }}
          >
            <CustomNewTabForm
              ref={customFormRef}
              formName="newuser1"
              onSubmit={onSubmit}
              resetData={false}
              formValues={userData}
              twoColumns={true}
              fieldRendererType={"registration"}
              disable={editAllowed || closeButtonDisabled}
              conditionalFields={customerProfileConditionalFields}
              renderButton={false}
              isEdit={true}
              conditionalGroups={conditionalGroups}
              customerTypes={customerTypes}
              customerSubTypes={customerSubTypes}
              setSelectedCustomerType={setSelectedCustomerType}
              renderFieldsetsAsTabs={"newuser1"}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "right",
              '@media (min-width: 1920px)': {
                marginTop: "40px",
                marginRight: "20px",
              },
              marginTop: "40px",
              marginBottom: "20px",
              marginRight: "20px",
            }}
          >
            {isOperator === 'true' &&
            <Box
              sx={{
                color: "#fff",
                textTransform: "capitalize",
                fontFamily: "Inter",
                borderRadius: "8px",
                fontSize: "12px",
                marginBottom: "30px",
                '@media (min-width: 1520px)': {
                  marginBottom: "80px",
                },
              }}
            />}
            {isOperator === 'false' && 
            <BaseButton
              buttonText={loading ? "Saving....." : "Save Changes"}
              onClick={(e) => onSubmit(e)}
              disabled={loading}
              buttonStyle="save-button"
            />
          }
          </Box>
        </Box>
      )}

      {showPinPad && (
        <PinPad
          show={showPinPad}
          handleConfirm={handleConfirm}
          onClick={() => setShowPinPad(false)}
        />
      )}
      <CustomAlert
        severity={alert.severity}
        show={alert.showAlert}
        header={alert.header}
        message={alert.message}
        onClick={
        (prevDetails) => {
          setAlert({ ...prevDetails, showAlert: false }); 
          if (alert.severity === "success") handleClose()
        }
      }
        alertType={alert.alertType}
        confirmButton={alert.onConfirm}
        autoclose={alert.severity === "error" ? false : true}
      />
    </Box>
  );
}

export default CustomerProfile;